export default "__VITE_ASSET__POBlOVzj__"